import { render, staticRenderFns } from "./vmenu.vue?vue&type=template&id=3c12e8c0"
import script from "./vmenu.vue?vue&type=script&lang=js"
export * from "./vmenu.vue?vue&type=script&lang=js"
import style0 from "./vmenu.vue?vue&type=style&index=0&id=3c12e8c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports